<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="代理商账号" prop="userId">
						<el-input v-model="formInline.userId" placeholder="请输入代理商账号" clearable @keyup.enter.native="search"
							@clear="search"></el-input>
					</el-form-item>
					<el-form-item label="代理商姓名" prop="uId" v-if="!isAgent">
						<el-select v-model="formInline.uId" placeholder="请选择代理商姓名" clearable @change="search" filterable>
							<el-option v-for="item in agentIdOptions" :key="item.id" :label="item.nickName"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="日期：">
						<el-date-picker v-model="dataTime" class="pickerData" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
					v-loading="loading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="statDate" label="日期" width="100">
					</el-table-column>
					<el-table-column prop="title" label="代理商信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>代理商账号：{{ scope.row.agentId }}</p>
								<p>代理商姓名：{{ scope.row.nickName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日总数据" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日充值人数：{{ scope.row.recDayUserNum }}</p>
								<p>当日充值金额：{{ scope.row.recDay }}</p>
								<p>当日充值次数：{{ scope.row.recDayNum }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="新用户数据">
						<template slot-scope="scope">
							<div class="td-info">
								<p>新用户数: {{ scope.row.newUserNum }}</p>
								<p>新用户充值人数:{{ scope.row.newUserRecUserNum }} </p>
								<p>新用户充值金额: {{ scope.row.newUserRec }}</p>
								<p>新用户人均充值: {{ scope.row.newUserAvgRec }}</p>
								<p>新用户付费率: {{ scope.row.newUserPaymentRate }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="总用户数据" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总用户数：{{ scope.row.userNumTotal }}</p>
								<p>总充值人数：{{ scope.row.recUserNumTotal }}</p>
								<p>总充值金额：{{ scope.row.recTotal }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="广告数据" width="240">
						<template slot-scope="scope">
							<div class="td-info">
								<p>有效广告曝光总数IPU：{{ scope.row.ipu }}</p>
								<p>当日新用户平均ECPM：{{ scope.row.newUserEcpm }}</p>
								<p>当日总平均ECPM：{{ scope.row.ecpm }}</p>
								<p>当日广告预估总收入：{{ scope.row.adIne }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="订单数">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总订单数：{{ scope.row.orderNumTotal }}</p>
								<p>未支付数：{{ scope.row.orderNoPayNumTotal }}</p>
								<p>支付数：{{ scope.row.orderPayNumTotal }}</p>
								<p>充值成功率：{{ scope.row.paymentRate }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="回传信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日广告完播总次数：{{ scope.row.playAdNum }}</p>
								<p>当日广告已回传笔数：{{ scope.row.retNum }}</p>
								<p>当日广告回传人数：{{ scope.row.retUserNum }}</p>
								<p>当日付费回传笔数：{{ scope.row.retPayNum }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">日期</td>
						<td>
							<p>{{ rowForm.statDate }}</p>
						</td>
					</tr>
					<tr>
						<td width="200">代理商信息</td>
						<td>
							<p>代理商账号：{{ rowForm.agentId }}</p>
							<p>代理商姓名：{{ rowForm.nickName }}</p>
						</td>
					</tr>
					<tr>
						<td>当日总数据</td>
						<td>
							<p>当日充值人数：{{ rowForm.recDayUserNum }}</p>
							<p>当日充值金额：{{ rowForm.recDay }}</p>
							<p>当日充值：{{ rowForm.recDayNum }}</p>
						</td>
					</tr>
					<tr>
						<td>新用户数据</td>
						<td>
							<p>新用户数: {{ rowForm.newUserNum }}</p>
							<p>新用户充值人数:{{ rowForm.newUserRecUserNum }} </p>
							<p>新用户充值金额: {{ rowForm.newUserRecUserNum }}</p>
							<p>新用户人均充值: {{ rowForm.newUserAvgRec }}</p>
							<p>新用户付费率: {{ rowForm.newUserPaymentRate }}</p>
						</td>
					</tr>
					<tr>
						<td>总用户数据</td>
						<td>
							<p>总用户数：{{ rowForm.userNumTotal }}</p>
							<p>总充值人数：{{ rowForm.recUserNumTotal }}</p>
							<p>总充值金额：{{ rowForm.recTotal }}</p>
						</td>
					</tr>
					<tr>
						<td>广告数据</td>
						<td>
							<p>有效广告曝光总数IPU：{{ rowForm.ipu }}</p>
							<p>当日新用户平均ECPM：{{ rowForm.newUserEcpm }}</p>
							<p>当日总平均ECPM：{{ rowForm.ecpm }}</p>
							<p>当日广告预估总收入：{{ rowForm.adIne }}</p>
						</td>
					</tr>
					<tr>
						<td>订单数</td>
						<td>
							<p>总订单数：{{ rowForm.orderNumTotal }}</p>
							<p>未支付数：{{ rowForm.orderNoPayNumTotal }}</p>
							<p>支付数：{{ rowForm.orderPayNumTotal }}</p>
							<p>充值成功率：{{ rowForm.paymentRate }}</p>
						</td>
					</tr>
					<tr>
						<td>回传信息</td>
						<td>
							<p>当日广告完播总次数：{{ rowForm.playAdNum }}</p>
							<p>当日广告已回传笔数：{{ rowForm.retNum }}</p>
							<p>当日广告回传人数：{{ rowForm.retUserNum }}</p>
							<p>当日付费回传笔数：{{ rowForm.retPayNum }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { list, agentlist } from "@/api/dysvzk/data/account";
export default {
	data() {
		return {
			loading: false,
			dataTime: [],
			formInline: {
				statStartDate: '',
				statEndDate: '',
				appId: localStorage.getItem('appId'),
				userId: '',
				uId: ''
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogInfoVisible: false,
			rowForm: {},
			isAgent: false,
			agentIdOptions: [],
		}
	},
	computed: {},
	watch: {
	},
	mounted: function () {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isAgent = true
			this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.loading = true
		this.getTableData()
		this.getAgentList()
	},
	methods: {
		// 从组件获取appid
		getAppId(data) {
			this.loading = true
			this.formInline.appId = data
			this.getTableData()
		},
		getCurrentDate() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			return year + '-' + month + '-' + day;
		},
		search () {
			this.loading = true
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery: function () {
			this.loading = true
			this.$refs['formInline'].resetFields()
			this.dataTime = []
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.loading = true
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.loading = true
			this.getTableData()
		},
		handleLook(row) {
			this.dialogInfoVisible = true
			this.rowForm = row
		},
		//
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
			this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			list(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
					this.loading = false
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		//获取代理商列表
		getAgentList() {
			agentlist().then(response => {
				if (response.data.head.flag === 0) {
					this.agentIdOptions = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
	}
}
</script>
